// Le pagine pubbliche Privacy e Termini di utilizzo (tela «PopTown Pop Style», artboard «Privacy e
// Termini»): le chiede la schermata di consenso OAuth di Google. Si montano fuori dalla plancia
// (main.tsx): niente store, niente stream, nessuna chiamata all'API, solo testo fisso.
// Richiesta dell'utente del 2026-11-01: «fai la base base non entrare nei dettagli», «rotte
// separate».
import { PopTownMark, PopTownName } from '../../components/Brand';

type Section = { h: string; p: string };
type Legal = { title: string; sections: Section[] };

export const LEGAL_PATHS: Record<string, Legal> = {
  '/privacy': {
    title: 'Privacy',
    sections: [
      {
        h: 'Chi gestisce PopTown',
        p: 'PopTown è un’applicazione ospitata in proprio e usata dal suo amministratore. Non è un servizio aperto al pubblico: per entrare servono credenziali date dall’amministratore.',
      },
      {
        h: 'Quali dati usa',
        p: 'Con il tuo consenso PopTown legge e gestisce la posta Gmail e il calendario degli account che colleghi, solo per le attività che chiedi. Le credenziali restano cifrate sul server di PopTown.',
      },
      {
        h: 'Cosa non fa',
        p: 'Non vende i dati, non li usa per pubblicità e non li usa per addestrare modelli. L’uso dei dati ricevuti dalle API di Google rispetta le Google API Services User Data Policy, compresi i requisiti di Limited Use.',
      },
      {
        h: 'Come revocare',
        p: 'Scollega l’account da Strumenti, oppure togli l’accesso da myaccount.google.com/permissions.',
      },
    ],
  },
  '/termini-di-utilizzo': {
    title: 'Termini di utilizzo',
    sections: [
      {
        h: 'Uso',
        p: 'PopTown è uno strumento personale ospitato in proprio. Lo usano solo le persone a cui l’amministratore dà un accesso.',
      },
      {
        h: 'Responsabilità',
        p: 'Le attività degli agenti partono su richiesta di chi usa PopTown, che ne resta responsabile. PopTown è fornito così com’è, senza garanzie.',
      },
      {
        h: 'Servizi collegati',
        p: 'Gli account collegati (per esempio Google) restano soggetti ai termini dei rispettivi servizi.',
      },
      {
        h: 'Modifiche',
        p: 'Questi termini possono cambiare: la data in cima dice quando sono stati aggiornati.',
      },
    ],
  },
};

const UPDATED = 'Ultimo aggiornamento: 1° novembre 2026';

export function LegalPage({ path }: { path: string }) {
  const page = LEGAL_PATHS[path];
  document.title = `${page.title} · PopTown`;
  return (
    <div className="legal">
      <div className="legal-inner">
        <header className="legal-brand">
          <PopTownMark size={40} />
          <PopTownName size={24} />
        </header>
        <article className="legal-card">
          <div>
            <h1 className="legal-title">{page.title}</h1>
            <p className="legal-date">{UPDATED}</p>
          </div>
          {page.sections.map((s) => (
            <section key={s.h} className="legal-section">
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </section>
          ))}
        </article>
        <nav aria-label="Pagine legali" className="legal-nav">
          <a href="/privacy">Privacy</a>
          <a href="/termini-di-utilizzo">Termini di utilizzo</a>
          <a href="/">Torna a PopTown</a>
        </nav>
      </div>
    </div>
  );
}
